class MasonryComponent extends SliderComponent {
  constructor() {
    super();
    this.loadMoreReset = null;
    this.loadMoreButton = null;
    this.countText = null;
    this.articles = null;
    this.currentItems = 0;
    this.resizing = false;

    window.addEventListener('resize', () => this.resizeActions());
    if (window.innerWidth <= 576) this.initLoadMore();
  }

  initLoadMore() {
    const self = this;
    self.loadMoreButton = self.querySelector(
      '.petivity-article-collection__load-more-wrapper a',
    );
    self.countText = self.querySelector(
      '.petivity-article-collection__count-text',
    );
    self.articles = [...self.querySelectorAll('.masonry-item')];
    const initialCount = 3;
    self.currentItems = initialCount;

    self.loadMoreButton.setAttribute('aria-label', 'View more');

    self.articles
      .slice(0, self.currentItems)
      .forEach((article) => article.classList.add('show'));

    self.countText.textContent = `Showing ${self.currentItems} of ${self.articles.length} articles`;
    self.loadMoreButton.addEventListener('click', (e) =>
      self.loadMoreHandler(e, initialCount),
    );
  }

  loadMoreHandler(e, initialCount) {
    e.preventDefault();
    const buttonLabel = this.loadMoreButton.querySelector('.d2c-button__label');
    if (this.currentItems < this.articles.length) {
      // LOAD MORE logic
      const nextItems = this.articles.slice(
        this.currentItems,
        this.currentItems + 3,
      );
      nextItems.forEach((item) => item.classList.add('show'));
      this.currentItems += 3;

      setTimeout(() => {
        if (e.pointerType !== 'touch') nextItems[0].querySelector('a').focus();
        nextItems[0].scrollIntoView({behavior: 'smooth'});
      }, 100);

      if (this.currentItems >= this.articles.length) {
        buttonLabel.textContent = 'View Less';
        this.loadMoreButton.setAttribute('aria-label', 'View less');
        this.countText.textContent = `Showing ${this.articles.length} of ${this.articles.length} articles`;
      } else {
        this.countText.textContent = `Showing ${this.currentItems} of ${this.articles.length} articles`;
      }
    } else {
      // SHOW LESS logic
      this.articles
        .slice(initialCount)
        .forEach((item) => item.classList.remove('show'));
      this.currentItems = initialCount;
      buttonLabel.textContent = 'View More';
      this.loadMoreButton.setAttribute('aria-label', 'View more');

      // Optional: Scroll back to top of container
      setTimeout(() => {
        buttonLabel.scrollIntoView({behavior: 'smooth', block: 'center'});
      }, 100);
      this.countText.textContent = `Showing ${this.currentItems} of ${this.articles.length} articles`;
    }
  }

  resizeActions() {
    if (!this.resizing) {
      this.resizing = true;

      setTimeout(() => {
        if (window.innerWidth <= 576) {
          this.initLoadMore();
        } else {
          this.articles = [...this.querySelectorAll('.masonry-item')];
          this.articles.forEach((item) => item.classList.remove('show'));
          this.loadMoreButton.removeEventListener(
            'click',
            this.loadMoreHandler,
          );
        }
        this.resizing = false;
      }, 1000);
    }
  }
}

customElements.define('masonry-component', MasonryComponent);
